export default __webpack_public_path__ + "static/media/inline6.ba087c1e.jpg";